<template>
  <div class="main">
    <el-form
      :model="loginForm.data"
      status-icon
      :rules="loginForm.rules"
      ref="data1loginForm"
      class="demo-ruleForm"
      v-loading.lock="loginForm.loading"
    >
      <h1>金豐集團形象網站管理系統</h1>
      <el-form-item label="帳號" prop="account">
        <el-input
          type="text"
          v-model.trim="loginForm.data.account"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="密碼" prop="password">
        <el-input
          type="password"
          v-model.trim="loginForm.data.password"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="驗證碼" prop="password">
        <el-input
          type="text"
          v-model.trim="loginForm.data.captchaCode"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <div class="captcha-box">
          <el-image
            @click="updateCaptchaCode()"
            style="width: 123px; height: 44px"
            :src="captchaImageUrl"
          ></el-image>
          <el-button size="small" @click="updateCaptchaCode()"
            >看不清楚嗎? 換一張新的!</el-button
          >
        </div>
      </el-form-item>
      <el-form-item label="" prop="">
        <el-alert
          v-show="loginForm.errorMessage.length > 0"
          type="error"
          :closable="false"
          >{{ loginForm.errorMessage }}
        </el-alert>
      </el-form-item>
      <el-form-item>
        <div class="formSubmitBtnBox">
          <el-button type="primary" @click="login()">登入</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { CheckAdminLogin, AdminLogin, CaptchaImage_Get } from '@/assets/js/api';

export default {
  metaInfo() {
    return {
      title: '登入 | 金豐集團形象網站管理系統',
    };
  },
  data() {
    return {
      captchaImageUrl: '',
      loginForm: {
        dialogVisible: false,
        loading: false,
        formRef: 'data1loginForm',
        errorMessage: '',
        data: {
          account: '',
          password: '',
          captchaCode: '',
        },
        rules: {
          account: [{ required: true, message: '請輸入帳號' }],
          password: [{ required: true, message: '請輸入密碼' }],
          captchaCode: [{ required: true, message: '請輸入驗證碼' }],
        },
      },
    };
  },
  mounted() {
    this.updateCaptchaCode();
  },
  created() {
    CheckAdminLogin()
      .then((res) => {
        let admin = sessionStorage.getItem('_admin');
        const checkStatus = res.data.data.loginStatus;
        sessionStorage.setItem('_lgists', checkStatus ? 1 : 0);
        if (checkStatus) {
          this.$router.push('/');
          if (res.data.data.devEnv) {
            admin = 'kingfongAdmin';
          }
          if (admin !== 'kingfongAdmin') {
            this.$router.push('/certificate');
          }
        }
      })
      .catch((err) => {
        this.$notify.error({
          title: '錯誤',
          message: err.response.data.message,
        });
      });
  },
  methods: {
    login() {
      this.$refs[this.loginForm.formRef].validate((valid) => {
        if (valid) {
          this.loginForm.loading = true;
          this.loginForm.errorMessage = '';
          AdminLogin(this.loginForm.data)
            .then((res) => {
              sessionStorage.setItem('_admin', res.data.data);
              this.$router.push('/');
            })
            .catch((err) => {
              this.updateCaptchaCode();
              this.loginForm.loading = false;
              this.loginForm.errorMessage = err.response.data.message;
            });
        }
      });
    },
    updateCaptchaCode() {
      this.captchaImageUrl = `${CaptchaImage_Get()}?${+new Date()}`;
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.main {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  form {
    padding: 3rem;
    display: inline-block;
    border: 1px solid black;
    border-radius: 5px;
    .captcha-box {
      display: flex;
      align-items: center;
      .el-image {
        cursor: pointer;
        margin-right: 1rem;
      }
    }
    .formSubmitBtnBox {
      text-align: center;
    }
  }
}
</style>
